import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { PositionSelect } from "shared";
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormWatch,
  useFieldArray,
} from "react-hook-form";
import { OmittedEmployee } from "entitites/employees/model/employee";
import MenuItem from "@mui/material/MenuItem";

export const ProfBody = ({
  register,
  errors,
  control,
  watch,
}: {
  register: UseFormRegister<OmittedEmployee>;
  errors: FieldErrors<OmittedEmployee>;
  control: Control<OmittedEmployee>;
  watch: UseFormWatch<OmittedEmployee>;
}) => {
  const { fields, append, remove } = useFieldArray({
    name: "profInfo.additionalFields",
    control,
  });

  return (
    <Box width="100%" display="flex" gap={1.25} flexDirection="column">
      <Typography fontWeight={700} color="green.primary" variant="h6">
        Профессиональная информация
      </Typography>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Позиция
        <PositionSelect
          value={watch("profInfo.positionId")}
          sx={{ ml: "auto", width: 400 }}
          inputProps={register("profInfo.positionId", {
            required: "Пожалуйста введите позицию",
          })}
          error={Boolean(errors.profInfo?.positionId)}
          helperText={errors.profInfo?.positionId?.message}
        />
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Компания
        <TextField
          inputProps={register("profInfo.company", {
            required: "Пожалуйста введите компанию",
          })}
          error={Boolean(errors.profInfo?.company)}
          helperText={errors.profInfo?.company?.message}
          label="Компания"
          size="small"
          sx={{
            ml: "auto",
            width: 400,
          }}
        />
      </Box>
      {/* <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Направление
        <TextField
          inputProps={register("profInfo.direction", {
            required: "Пожалуйста введите направление",
          })}
          error={Boolean(errors.profInfo?.direction)}
          helperText={errors.profInfo?.direction?.message}
          label="Направление"
          size="small"
          sx={{
            ml: "auto",
            width: 400,
          }}
        />
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Отдел
        <TextField
          inputProps={register("profInfo.department", {
            required: "Пожалуйста введите отдел",
          })}
          error={Boolean(errors.profInfo?.department)}
          helperText={errors.profInfo?.department?.message}
          label="Отдел"
          size="small"
          sx={{
            ml: "auto",
            width: 400,
          }}
        />
      </Box> */}
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Проект
        <TextField
          select
          inputProps={register("profInfo.project")}
          label="Проект"
          size="small"
          sx={{
            ml: "auto",
            width: 400,
          }}
          value={watch("profInfo.project")}
        >
          <MenuItem value="Самокат">Самокат</MenuItem>
          <MenuItem value="Мегамаркет">Мегамаркет</MenuItem>
          <MenuItem value="Сберлогистика">Сберлогистика</MenuItem>
        </TextField>
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        График
        <TextField
          inputProps={register("profInfo.schedule", {
            required: "Пожалуйста введите график",
          })}
          error={Boolean(errors.profInfo?.schedule)}
          helperText={errors.profInfo?.schedule?.message}
          label="График"
          size="small"
          sx={{
            ml: "auto",
            width: 400,
          }}
        />
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Часы работы
        <TextField
          inputProps={register("profInfo.workTime", {
            required: "Пожалуйста введите часы работы",
          })}
          error={Boolean(errors.profInfo?.workTime)}
          helperText={errors.profInfo?.workTime?.message}
          label="Часы работы"
          size="small"
          sx={{
            ml: "auto",
            width: 400,
          }}
        />
      </Box>
      {fields.map((field, index) => (
        <Box
          key={field.id}
          display="flex"
          alignItems="center"
          fontWeight={600}
          width="100%"
          gap={1}
        >
          <TextField
            fullWidth
            inputProps={register(`profInfo.additionalFields.${index}.label`)}
            label="Название"
            size="small"
          />
          <TextField
            fullWidth
            inputProps={register(`profInfo.additionalFields.${index}.value`)}
            label="Значение"
            size="small"
          />
          <Button
            disableTouchRipple
            disableElevation
            sx={{
              textTransform: "none",
              fontWeight: 700,
              minWidth: 32,
            }}
            variant="contained"
            onClick={() => remove(index)}
          >
            -
          </Button>
        </Box>
      ))}
      <Button
        disableTouchRipple
        disableElevation
        sx={{
          textTransform: "none",
          fontWeight: 700,
        }}
        variant="contained"
        onClick={() => append({ label: "", value: "" })}
      >
        Добавить профессиональную информацию +
      </Button>
    </Box>
  );
};
